import keyMirror from 'keymirror'

export default keyMirror({
  GET_BO_VERSIONS_REQUEST: null,
  GET_BO_VERSIONS_SUCCESS: null,
  GET_BO_VERSIONS_FAILED: null,

  ADD_BO_VERSION_REQUEST: null,
  ADD_BO_VERSION_SUCCESS: null,
  ADD_BO_VERSION_FAILED: null,

  UPDATE_BO_VERSION_REQUEST: null,
  UPDATE_BO_VERSION_SUCCESS: null,
  UPDATE_BO_VERSION_FAILED: null,

  DELETE_BO_VERSION_REQUEST: null,
  DELETE_BO_VERSION_SUCCESS: null,
  DELETE_BO_VERSION_FAILED: null,

  UPDATE_BO_VERSION_FILTER_SUCCESS: null
})
